"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySonyOptIn = void 0;
const event_1 = require("../event");
/** Custom-field id for the Sony Music email opt-in checkbox. */
const SONY_OPTIN_FIELD_ID = "optin-sony";
/** Marker attribute used to identify (and re-strip) the Sony policy disclaimer. */
const SONY_DISCLAIMER_MARKER = "data-sony-policy";
/**
 * Applies the Sony Music email opt-in (required) to an event `register`, in
 * place — stripping any prior one first so it's correct across venue changes.
 * Ordered between the email (`terms`) and SMS (`sms`) opt-ins, after custom
 * consent when present. The opt-in's Terms/Privacy links are appended to the
 * form's footer `disclaimers` (mirroring how UMG adds its policies). `optIn` is
 * resolved for the venue's country by the caller (it's an async Firestore read;
 * this stays synchronous).
 */
const applySonyOptIn = (register, optIn, artistName) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((_a = register.customFields) === null || _a === void 0 ? void 0 : _a.length) {
        register.customFields = register.customFields.filter((f) => f.id !== SONY_OPTIN_FIELD_ID);
        if (!register.customFields.length)
            delete register.customFields;
    }
    if ((_b = register.fieldsOrder) === null || _b === void 0 ? void 0 : _b.length) {
        register.fieldsOrder = register.fieldsOrder.filter((f) => f.id !== SONY_OPTIN_FIELD_ID);
        if (!register.fieldsOrder.length)
            delete register.fieldsOrder;
    }
    if ((_c = register.disclaimers) === null || _c === void 0 ? void 0 : _c.length) {
        register.disclaimers = register.disclaimers.filter((d) => !d.includes(SONY_DISCLAIMER_MARKER));
        if (!register.disclaimers.length)
            delete register.disclaimers;
    }
    if (!optIn)
        return;
    register.customFields = [
        ...((_d = register.customFields) !== null && _d !== void 0 ? _d : []),
        {
            id: SONY_OPTIN_FIELD_ID,
            type: "checkbox",
            required: true,
            label: optIn.email.replace(/ARTIST/g, artistName),
        },
    ];
    const ordered = ["terms"];
    if (register.customFields.some((f) => f.id === event_1.CUSTOM_CONSENT_FIELD_ID)) {
        ordered.push(event_1.CUSTOM_CONSENT_FIELD_ID);
    }
    ordered.push(SONY_OPTIN_FIELD_ID);
    if (register.sms)
        ordered.push("sms");
    const rest = ((_e = register.fieldsOrder) !== null && _e !== void 0 ? _e : []).filter((f) => !ordered.includes(f.id));
    register.fieldsOrder = [
        ...ordered.map((id, index) => ({ id, index })),
        ...rest.map((f, i) => ({ id: f.id, index: i + ordered.length })),
    ];
    // Append the country's Terms/Privacy links to the footer disclaimers.
    const links = [];
    if (optIn.termsUrl) {
        links.push(link(optIn.termsUrl, (_f = optIn.termsLabel) !== null && _f !== void 0 ? _f : "Terms and Conditions"));
    }
    if (optIn.privacyUrl) {
        links.push(link(optIn.privacyUrl, (_g = optIn.privacyLabel) !== null && _g !== void 0 ? _g : "Privacy Policy"));
    }
    if (links.length) {
        register.disclaimers = [
            ...((_h = register.disclaimers) !== null && _h !== void 0 ? _h : []),
            `<span ${SONY_DISCLAIMER_MARKER}>Sony Music: ${links.join(" · ")}</span>`,
        ];
    }
};
exports.applySonyOptIn = applySonyOptIn;
const link = (href, text) => `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
//# sourceMappingURL=sony.js.map